import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { colors, font, shadow } from '@mobi/component-library/Foundations'
import { GridCell } from '@mobi/component-library/Legacy/Grid'
import { GridRowStyled } from '@mobi/component-library/Legacy/Grid/Grid.styles'
import { hexColors } from '@mobi/settings'
import { ButtonBlock } from '@core/Components/Buttons/ButtonBlock'

export const BetOfferContainerStyled = styled.div({
  backgroundColor: hexColors.white,
  boxShadow: shadow.xs,
  border: `0.1rem solid ${colors.neutral[200]}`,
  margin: '1.3em 1em 1.3em 1em',
  borderRadius: '1.2rem',
})

export const BonusHeaderRowStyled = styled(GridRowStyled)({
  marginTop: '-0.6rem',
  borderTopLeftRadius: '1.2rem',
  borderTopRightRadius: '1.2rem',
  backgroundColor: hexColors.orange,
  minHeight: '3.6rem',
})

export const BonusHeaderTitle = styled.div({
  fontFamily: font.family.primary,
  fontWeight: font.weight.semibold,
  fontSize: font.size.lg.fontSize,
  lineHeight: font.size.lg.lineHeight,
  color: hexColors.blueDiamond,
  paddingTop: '0.2rem',
})

export const BonusCellStyled = styled(GridCell)({
  marginLeft: '0.5rem',
  display: 'flex',
  gap: '0.5rem',
})

export const BonusExpiryDateStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  fontFamily: font.family.primary,
  fontWeight: font.weight.regular,
  fontSize: font.size.md.fontSize,
  lineHeight: font.size.md.lineHeight,
  paddingRight: '1rem',
  color: colors.studio[700],
})

export const BonusIconStyled = styled(Icon)({
  marginTop: '0.5rem',
  paddingTop: '0.2rem',
})

export const BonusDetailRowStyled = styled(GridRowStyled)({
  fontFamily: font.family.primary,
  fontWeight: font.weight.semibold,
  fontSize: font.size.lg.fontSize,
  lineHeight: font.size.lg.lineHeight,
  backgroundColor: hexColors.white,
  padding: '1em 0 0 0.85em',
})

export const BonusAmountsRowStyled = styled(GridRowStyled)({
  fontSize: '1.1em',
  backgroundColor: hexColors.white,
  padding: '1em 1em 0 1em',
})

export const BonusAmountsHeadingStyled = styled.div({
  fontSize: '1em',
  color: hexColors.grey,
})

export const BonusAmountsValueStyled = styled.div({
  fontSize: '1.2em',
  fontWeight: 'bold',
})

export const BonusFinePrintRowStyled = styled(GridRowStyled)({
  backgroundColor: hexColors.white,
  color: colors.neutral[800],
  fontFamily: font.family.primary,
  fontWeight: font.weight.regular,
  fontSize: font.size.md.fontSize,
  lineHeight: font.size.md.lineHeight,
  padding: '0.3rem 1rem 0.3rem 1rem',
  marginBottom: '0.2em',
})

export const BonusButtonRowStyled = styled(GridRowStyled)({
  fontSize: '1.1em',
  backgroundColor: hexColors.white,
  margin: '0 0.2em 0.2em 0.2em',
  borderRadius: '1.2rem',
})

export const BonusButtonCellStyled = styled(GridCell)({
  width: '100%',
  padding: '0.3em',
})

export const ButtonBlockStyled = styled(ButtonBlock)({
  borderRadius: '1rem',
  fontFamily: font.family.primary,
  fontWeight: font.weight.medium,
  fontSize: font.size.lg.fontSize,
  lineHeight: font.size.lg.lineHeight,
  backgroundColor: colors.studio[500],
  margin: '0.5rem 0 0.2rem 0',
  '&:hover': {
    backgroundColor: colors.studio[600],
  },
  '&:active': {
    backgroundColor: colors.studio[600],
  },
})

export const OfferCountAggregateDivStyled = styled.div({
  backgroundColor: colors.lavender[100],
  borderRadius: '1.6rem',
  color: colors.lavender[600],
  fontFamily: font.family.primary,
  fontWeight: font.weight.medium,
  fontSize: font.size.md.fontSize,
  lineHeight: font.size.md.lineHeight,
  marginLeft: '0.4rem',
  padding: '0 0.8rem 0 0.8rem',
})

export const BonusSubHeaderContainerStyled = styled.div({
  display: 'flex',
  height: '4.4rem',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: colors.white,
  borderBottom: `0.1rem solid ${hexColors.veryLightGrey}`,
  borderColor: colors.neutral[200],
  fontFamily: font.family.primary,

  button: {
    textAlign: 'left',
    fontWeight: font.weight.medium,
    fontSize: font.size.lg.fontSize,
    lineHeight: font.size.lg.lineHeight,
    color: colors.black,
    paddingLeft: '1.6rem',
  },

  'p:first-of-type': {
    textAlign: 'left',
    fontWeight: font.weight.semibold,
    fontSize: font.size.lg.fontSize,
    lineHeight: font.size.lg.lineHeight,
    color: colors.black,
    paddingRight: '1.6rem',
  },
})

export const TermsAndConditionsLinkStyled = styled.a({
  color: colors.neutral[800],
})
